<template>
    <form @submit.prevent="formSubmit">
        <div class="form-group basic">
          <div class="input-wrapper">
            <label class="label" for="form-recharge-asset">Activo</label>
            <select class="form-control custom-select" id="form-recharge-asset" v-model="assetSelected" required>
              <template v-for="(asset, a_i) in portfolio" v-bind:key="'form-blocking-asset-'+a_i">
                <option :value="a_i" v-if="this.portfolio[a_i].networks_recharge.length > 0">
                  {{asset.name}} ({{asset.symbol}})
                </option>
              </template>
            </select>
          </div>
        </div>
        <div class="form-group basic">
            <div class="input-wrapper" v-if="networksList.length > 0">
                <label class="label" for="account1">Red donde quieres recibir</label>
                <select class="form-control custom-select" id="form-recharge-network" v-model="networkSelected" required>
                    <option v-for="(network, n_i) in networksList" v-bind:key="'form-recharge-network-'+n_i" :value="n_i">
                      <!-- {{network.name}} -->
                        {{network.src.network.name}} ({{ $root.recortarCadena(network.src.contract_address) }})
                    </option>
                </select>
            </div>
        </div>

        <!-- <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account1">Desde</label>
                <select class="form-control custom-select" id="account1" v-model="form.network">
                    <option v-for="(network, n_i) in networks" v-bind:key="'ni'+n_i" :value="n_i">{{network.name}}</option>
                </select>
            </div>
        </div>
        <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account1">Activo ({{ $root.recortarCadena(asset.address) }})</label>
                <select class="form-control custom-select" id="account1" v-model="form.asset">
                    <option v-for="(asset, a_i) in assets" v-bind:key="'ai'+a_i" :value="a_i">{{asset.currency.name}} ({{asset.currency.symbol}})</option>
                </select>
            </div>
        </div> -->

        <div class="section" v-if="networksList.length > 0">
            <div class="splash-page mt-2 mb-2">
              <h2 >Escanea el Código QR</h2>
              <!-- <h3 >{{asset.type}}</h3> -->
              <div class="mb-1">
                <img :src="codeQR" alt="Código QR" class="imaged square w320">
              </div>
              <h3 class="mb-1">{{networkItem.src.wallet_address}}</h3>
                <p>Recuerda verificar la red y el contrato del token.</p>
            </div>
        </div>

        <div class="form-group basic">
            <button type="submit" :disabled="sending" class="btn btn-primary btn-block btn-lg">Continuar</button>
        </div>
    </form>
</template>

<script>
import { ethers } from 'ethers';
import { mapActions, mapState } from 'vuex';
import QRCode from 'qrcode'
export default {
  name: 'HomeView',
  data() {
    return {
      // networks: [],
      sending: false,
      assetSelected: 0,
      networkSelected: 0,
      form: {
        network: 0,
        asset: 0,
      },
      codeQR: null,
    };
  },
  matches: {
    async 'form.network'() {
      this.form.asset = 0;
      try{
        let self = this
        await QRCode.toDataURL(self.networkItem.src.wallet_address,{type:'png'}, function (err, url) {
          console.log('url1', url)
          self.codeQR = url
        })
      } catch (err) {
        console.error(err)
        this.codeQR = '@/assets/img/sample/qr.png'
      }
    }
  },
  computed: {
    ...mapState(['portfolio']),
    assetItem() {
      return this.portfolio[this.assetSelected] ?? null;
    },
    networkItem() {
      return this.networksList[this.networkSelected] ?? null;
    },
    networksList() {
      return this.portfolio[this.assetSelected].networks_recharge ?? [];
    },
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
      try{
        let self = this
        await QRCode.toDataURL(self.networkItem.src.wallet_address,{type:'png'}, function (err, url) {
          console.log('url1', url)
          self.codeQR = url
        })
      } catch (err) {
        console.error(err)
        this.codeQR = '@/assets/img/sample/qr.png'
      }
  },
  methods: {
    ...mapActions(['newNotification']),
    /* eslint-disable */
    async formSubmit() {
      const self = this;
      self.sending = true;

      console.log('formSubmit')
      console.log('Validar saldo usando web3')
      console.log('network', this.networkItem)
      console.log('rpcs', this.networkItem.src.network.rpcs[0] ?? null)
      console.log('asset', this.assetItem)
      console.log('asset.contract_address', this.networkItem.src.contract_address)
      console.log('networkItem.wallet_address', this.networkItem.src.wallet_address)

      if (self.networkItem.src.network.rpcs.length == 0) {
        self.$swal.fire({
          title: "Red no accesible!",
          text: "No hay nodos de conexion para esta red, contacta con soporte.",
          icon: "error",
          draggable: false,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
        self.sending = false;
        return false;
      }

      const providerJson = self.networkItem.src.network.rpcs[0];
      console.log('providerJson', providerJson)
      let provider = null;
      provider = new ethers.JsonRpcProvider(`${providerJson}`);
      if (provider == null) {
        self.$swal.fire({
          title: "Error Web3!",
          text: "Error creando la instancia Web3.",
          icon: "error",
          draggable: false,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
        self.sending = false;
        return false;
      }

      console.log('provider', provider)
      const abi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}];
      const contract = new ethers.Contract(self.networkItem.src.contract_address, abi, provider);

      console.log('contract', contract)
      
      // Get token balance as BigNumber
      const balance = await contract.balanceOf(self.networkItem.src.wallet_address);
      const decimals = await contract.decimals();
      
      // Format the balance for display with 18 decimal places
      const balanceFormatted = ethers.formatUnits(balance, decimals);
      console.log("El saldo del titular es " + balanceFormatted + " " + self.assetItem.symbol);
      
      if (balance == 0) {
        self.$swal.fire({
          title: "Saldo insuficiente!",
          text: "Tu saldo es " + balanceFormatted + " " + self.assetItem.symbol,
          icon: "error",
          draggable: false,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
        self.sending = false;
        return false;
      }
      
      self.$swal.fire({
        title: "Saldo encontrado!",
        text: "Tu saldo a recargar es " + balanceFormatted + " " + self.assetItem.symbol,
        icon: "success",
        draggable: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, continuar!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          const redirect = `/verify/deposit/${self.networkSelected}/${self.assetSelected}`;
          console.log('redirect', redirect)
          location.replace(redirect)
        }
      });

      self.sending = false;
      return false;
    }
  }
}
</script>